export default "__VITE_ASSET__BKqyUnQi__"